import { render, staticRenderFns } from "./CategoryPrivilege.page.vue?vue&type=template&id=054535df&"
import script from "./CategoryPrivilege.page.vue?vue&type=script&lang=js&"
export * from "./CategoryPrivilege.page.vue?vue&type=script&lang=js&"
import style0 from "./CategoryPrivilege.page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports